module.exports = __webpack_public_path__ + "img/NOP.d2b91f30.png";